// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./css/components/_man-sup.scss
// module id = 50
// module chunks = 0